import React, { Component } from "react";
import _ from "lodash";
import {
  WithStyles,
  Modal,
  Theme,
  createStyles,
  Card,
  CardHeader,
  IconButton,
  Typography,
  CardContent,
  Grid,
  withStyles,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { MyPATTextField } from "../../common";
import goalManagementService from "../services/goalManagementService";
import { Error } from "@material-ui/icons";
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem } from "../../common/MyPATUploadPreview";
import MyPATUploader from "../../common/MyPATUploader";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

interface AddCareerOptionDialogProps extends WithStyles<typeof styles> {
  isDialogOpen: boolean;
  dialogCloseHandler: () => void;
  showMsg:Function,
}

interface ErrForm {
  careerName?: string;
  careerDescription?: string;
}

interface AddCareerOptionDialogState {
  formData: {
    careerName: string;
    careerDescription: string;
  };
  errForm: ErrForm;
  description:string;
}

const INITIAL_STATE: AddCareerOptionDialogState = {
  formData: {
    careerName: "",
    careerDescription: "",
  },
  errForm: {
    careerName: "",
    careerDescription: "",
  },
  description:''
};

class AddCareerOptionDialog extends Component<AddCareerOptionDialogProps,AddCareerOptionDialogState> {
  
  state = INITIAL_STATE;
  handleInputChange = (event: any) => {
    const { name, value } = event.target;
    const { formData } = this.state;
    const errors: ErrForm = {};
    if (value.length >0) {
      errors.careerName = "";
      errors.careerDescription =""
    }
  
   
    this.setState((prevState) => ({
      ...prevState,
      formData: { ...prevState.formData, [name]: value },
      errForm: errors,
    }));
   
  };

  createCareerHandler = () => {
    const { formData } = this.state;
    const errors: ErrForm = {};
    if (formData.careerName.length<3) {
      errors.careerName = "Three Character Required *";
    }
    if (formData.careerDescription.length<3) {
      errors.careerDescription = "Three Character Required *";
    }

    if (!_.isEmpty(errors)) {
      return this.setState({
        errForm: errors,
      });
    }

    // Create career
        goalManagementService
        .addCareer({
          name: formData.careerName,
          description: formData.careerDescription,
        })
        .then((res) => {
          this.handlePopUpClose();
        });
      
    
  };
  handlePopUpClose = () => {
    this.setState({
      ...INITIAL_STATE,
    });
    this.props.dialogCloseHandler();
  };
  render() {
    const { formData, errForm } = this.state;
    const { isDialogOpen, classes } = this.props;
    return (
      <Modal
        className={[
          classes.fontSizeLG,
          classes.fontWeight500,
          classes.modal,
        ].join(" ")}
        title="Add Career Option"
        open={isDialogOpen}
      >
        <div className={classes.paper}>
          <Card className={classes.cardContainer} elevation={0}>
            <CardHeader
              className={classes.modalHeader}
              action={
                <IconButton
                  aria-label="settings"
                  onClick={this.handlePopUpClose}
                >
                  <CloseIcon className={classes.fontSizeLG} />
                </IconButton>
              }
              title={
                <Typography
                  align="center"
                  className={[classes.fontWeight500, classes.fontSizeLG].join(
                    " "
                  )}
                >
                  Add Career Option
                </Typography>
              }
            />
            <CardContent>
              <Grid
                container
                spacing={8}
                alignItems="center"
                className={classes.cardContainer}
              >
                <Grid
                  container
                  className={[classes.formControllContainer, classes.mb1x].join(
                    " "
                  )}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={classes.fontSizeMD}
                    >
                      Career Name
                    </Typography>
                    <MyPATTextField
                      fullWidthControl
                      inputId="careerName"
                      name="careerName"
                      error={!!errForm.careerName}
                      errorText={errForm.careerName}
                      placeholder="Enter the course name"
                      value={formData.careerName}
                      onChange={this.handleInputChange}
                    />
                  </Grid>
                  <Grid
                    container
                    justify="space-between"
                    className={[classes.mb1x, classes.paddingLeft].join(" ")}
                  >
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={classes.fontSizeMD}
                    >
                      Description
                    </Typography>
                    
                    <MyPATTextField
                      fullWidthControl
                      inputId="careerDescription"
                      name="careerDescription"
                      placeholder="Enter the description"
                      error={!!errForm.careerDescription}
                      errorText={errForm.careerDescription}
                      value={formData.careerDescription}
                      onChange={this.handleInputChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container justify="flex-end" alignItems="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.doneBtn}
                 // disabled={this.disabledAddCta()}
                  onClick={this.createCareerHandler}
                >
                  Add
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  }
}


const styles = (theme: Theme) =>
  createStyles({
    root: {
      "&$checked": {
        color: "#1D7DEA !important",
      },
      "& label.MuiFormLabel-root": {
        fontSize: "1rem",
        color: "#33333",
      },
      "& p, a": {
        color: "#33333",
        fontSize: "1rem",
      },
    },
    doneBtn: {
      marginTop: 20,
    },
    mb1x: {
      marginBottom: theme.spacing.unit,
    },
    formControllContainer: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
    },
    fontSizeLG: {
      fontSize: "1.75rem",
    },
    fontSizeMD: {
      fontSize: "1rem",
    },
    paddingLeft: {
      // paddingLeft: "13px",
      // paddingRight: '14px'
    },
    fontWeight500: {
      fontWeight: 500,
    },
    cardContainer: {
      border: "1px solid #E1E1E1",
      borderRadius: 4,
    },
    modal: {
      display: "flex",
      padding: 12,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 4,
    },
    paper: {
      width: 680,
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      padding: "20, 40, 30",
      borderRadius: 4,
      outline: "#fff",
    },
    modalHeader: {
      height: 66,
      borderBottom: "1px solid #E2E2E2",
      background: "#fff",
      backgroundColor: "#fff",
    },
    fileLabel: {
      cursor: "pointer",
      padding: '0px 6px 0px 0px'
    },
    inputFile: {
      display: "none",
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      padding: '4px 20px',
      "& svg": {
        verticalAlign: "bottom",
      },
    },
    attachFileContainer: {
      background: "#FFFFFF",
      border: "1px solid #DFDFDF",
      boxSizing: "border-box",
      borderRadius: 4,
      width: '100%',
      '& .paddingMD': {
        padding: "6px 20px 4px",
      },
      '& .buttonSubLabel': {
        padding: "13px 0",
        '& p': {
          color: '#666'
        }
      },
      '& .attachmentIcon': {
        display: "inline-block",
        verticalAlign: "middle",
        paddingTop:8,
      },
      '& .padding30': {
          padding: '12px 0px 30px'
      },
      '& .uploadPreviewBox': {
        minHeight: 16,
        padding: "16px 0px 0px",
      },
      '& .heading': {
        padding: '16px 20px',
        borderBottom: "solid 1px rgb(223 223 223)",
        '& p': {
          fontSize: 18,
          fontWeight: 400
        }
      }
    },
  });
 

export default (withStyles(styles)(AddCareerOptionDialog));
